module.exports = __webpack_public_path__ + "img/title.f7c72315.png";